import React from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from './i18n';
import './AuthorizedUsersSkeleton.css';

export interface AuthorizedUsersSkeletonProps {
  rows?: number;
  /** False when drawn inside a skeleton that already announces itself. */
  announce?: boolean;
}

const Bone: React.FC<{ className: string }> = ({ className }) => (
  <span className={`authorized-users-skeleton__bone ${className}`} />
);

/** The End User Access rows while the list loads: username, key, status and the actions button. */
export function AuthorizedUsersSkeleton({
  rows = 5,
  announce = true,
}: AuthorizedUsersSkeletonProps): React.ReactElement {
  const { t } = useTranslation(NS);
  const bones = (
    <div aria-hidden="true">
      {Array.from({ length: rows }, (_, row) => (
        <div key={row} className="authorized-users-skeleton__row">
          <Bone className="authorized-users-skeleton__cell authorized-users-skeleton__cell--wide" />
          <Bone className="authorized-users-skeleton__cell authorized-users-skeleton__cell--key" />
          <span className="authorized-users-skeleton__status">
            <Bone className="authorized-users-skeleton__dot" />
            <Bone className="authorized-users-skeleton__cell authorized-users-skeleton__cell--status" />
          </span>
          <Bone className="authorized-users-skeleton__action" />
        </div>
      ))}
    </div>
  );

  if (!announce) {
    return <div className="authorized-users-skeleton">{bones}</div>;
  }
  return (
    <div
      className="authorized-users-skeleton"
      role="status"
      data-testid="authorized-users-skeleton"
    >
      <span className="authorized-users-skeleton__sr-only">{t('loadingUsers')}</span>
      {bones}
    </div>
  );
}
